<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />

                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-button class="item" icon="icon icon-jiarucopy" @click="on_create()" type="primary" />
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                size="middle"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
            >
                <!-- 创建时间 -->
                <template slot="created_render" slot-scope="text">{{ text ? moment(text * 1000).format("YYYY-MM-DD") : "" }}</template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <a-button size="small" style="margin-right: 8px" @click="on_approve(record)">审批设置</a-button>

                    <a-button size="small" style="margin-right: 8px" @click="on_edit(record)" :disabled="!!record.is_system">修改</a-button>
                    <a-button size="small" @click="on_delete(record)" type="danger" :disabled="!!record.is_system">删除</a-button>
                </template>
            </a-table>
        </div>

        <modal_create
            :visible="visible_create"
            @load="load"
            @close="visible_create = false"
            :record="selected_record"
            :mode="mode_create"
        />

        <!-- 审批设置 -->
        <modal_approve :visible="visible_approve" @close="visible_approve = false" :record="selected_record" :callback="load" />
    </div>
</template>
<script>
    import modal_create from "./modal_create.vue";
    import modal_approve from "./modal_approve.vue";
    import moment from "moment";

    export default {
        components: { modal_create, modal_approve },
        data() {
            return {
                path: "/setting/authority/group",
                visible_create: false,
                visible_approve: false,
                mode_create: "create",
                selected_record: null,
                wd: null,
                columns: [
                    {
                        dataIndex: "name",
                        title: "名称",
                        width: 120,
                    },
                    // {
                    //     dataIndex: 'is_default',
                    //     title: '是否默认',
                    // },
                    {
                        dataIndex: "is_system",
                        title: "系统内置",
                        width: 100,
                        customRender: (e) => (e ? "是" : ""),
                    },
                    {
                        dataIndex: "user_count",
                        title: "用户数",
                        width: 120,
                        customRender: (e) => e || "",
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                    },
                    {
                        dataIndex: "action",
                        title: "操作",
                        align: "center",
                        width: 200,
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
                data_source: [],
                loading: false,
            };
        },
        mounted() {
            this.load();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/auth/group?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_edit(row) {
                this.selected_record = row;
                this.mode_create = "edit";
                this.visible_create = true;
            },
            on_create() {
                this.selected_record = {};
                this.visible_create = true;
                this.mode_create = "create";
            },
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: "删除确认",
                    content: `是否删除【${record.name}】`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete("/auth/group/" + record.id)
                                .then((res) => {
                                    if (res.success) {
                                        this.$message.success(res.message);
                                        this.load();
                                    } else {
                                        this.$error({ title: "失败", content: res.message });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_approve(record) {
                this.selected_record = record;
                this.visible_approve = true;
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-body {
        .main {
            overflow-y: auto;
            position: absolute;
            top: 56px;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
</style>
